import _ from 'lodash';

export default {
  data() {
    return {
      contacts: [],
    };
  },
  methods: {
    /**
     * This function gets all FMCSA contacts.
     * @summary valid FMCSA contacts are stored in the contacts variable.
     */
    async getFMCSAContacts() {
      const carrierData = await this.$store.dispatch(
        'carriers/getCarrierEmailsAndPhones',
        this.$store.state.users.currentUser.requested_carrier_id
      );

      let emails = carrierData?.data?.email_addresses?.map((item) => ({
        ...item,
        channel: 'email',
      }));

      // Remove duplicate items in emails array
      emails = _.uniqBy(emails, (email) => {
        return email.value;
      });

      let phones = carrierData?.data?.phones?.map((phone) => ({
        ...phone,
        channel: 'call',
      }));

      /**
       * There are some types of telephones such as faxes that Twilio cannot call,
       * so the types of telephones supported by Twilio are filtered.
       */
      phones = phones.filter((phone) => {
        return (
          phone.is_type === 'census_main' || phone.is_type === 'census_cell'
        );
      });

      // Remove duplicate items in phones array
      phones = _.uniqBy(phones, (phone) => {
        return phone.phone_e164;
      });

      // Create a contact list with phone numbers and emails.
      this.contacts = [...emails, ...phones];

      /**
       * Some carriers will get their authority from the FMCSA by paying a company to do it for them.
       * The company who does it for them will put their own email address on file with the FMCSA.
       * If the company helps 100 different carriers get their authority,
       * then that company’s email address will be the FMCSA email address on file with each of the 100 carriers.
       * We want to hide this kind of email address from showing when a user is trying to prove he/she belongs to a carrier.
       */
      this.contacts = this.contacts.filter((contact) => {
        if ('commonly_reused_count' in contact) {
          if (contact.commonly_reused_count > 0) return false;
          return true;
        }
        return true;
      });
    },
    /**
     * This function gets only emails FMCSA contacts.
     * @summary valid FMCSA contacts are stored in the contacts variable.
     */
    async getEmailFMCSAContacts() {
      const carrierData = await this.$store.dispatch(
        'carriers/getCarrierEmailsAndPhones',
        this.$store.state.users.currentUser.requested_carrier_id
      );

      let emails = carrierData?.data?.email_addresses?.map((item) => ({
        ...item,
        channel: 'email',
      }));

      // Remove duplicate items in emails array
      emails = _.uniqBy(emails, (email) => {
        return email.value;
      });

      // Create a contact list with  emails.
      this.contacts = emails;

      /**
       * Some carriers will get their authority from the FMCSA by paying a company to do it for them.
       * The company who does it for them will put their own email address on file with the FMCSA.
       * If the company helps 100 different carriers get their authority,
       * then that company’s email address will be the FMCSA email address on file with each of the 100 carriers.
       * We want to hide this kind of email address from showing when a user is trying to prove he/she belongs to a carrier.
       */
      this.contacts = this.contacts.filter((contact) => {
        if ('commonly_reused_count' in contact) {
          if (contact.commonly_reused_count > 0) return false;
          return true;
        }
        return true;
      });
    },
  },
};
